import React from 'react';
import { Space } from 'antd';
import { Link } from 'react-router-dom';
import TableWithSorter from '../../../Common/TableWithSorter';

const ClassTable = ({
  data,
  offset,
  totalCount,
  onPaginationChange,
  pageSize,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
      render: (value, item, index) => <span>{offset + index + 1}</span>,
    },
    {
      title: 'Class Code',
      dataIndex: 'classCode',
      key: 'classCode',
      render: (text, record) => (
        <Space size="middle">
          <Link to={'/trial-class/' + record.classCode}>{text}</Link>
        </Space>
      ),
    },
    {
      title: 'Class Timezone',
      dataIndex: 'timezone',
      key: 'timezone',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Start Time',
      dataIndex: 'startDate',
      key: 'startDate',
      render: (value) => (
        <span>
          {new Date(value).toLocaleDateString() +
            ' ' +
            new Date(value).toLocaleTimeString()}
        </span>
      ),
    },
    {
      title: 'End Time',
      dataIndex: 'endDate',
      key: 'endDate',
      render: (value) => (
        <span>
          {new Date(value).toLocaleDateString() +
            ' ' +
            new Date(value).toLocaleTimeString()}
        </span>
      ),
    },
  ];

  return (
    <>
      <div>Total count: {totalCount}</div>
      {data.length > 0 ? (
        <div>
          `{' '}
          <TableWithSorter
            scroll={{ x: 1000 }}
            columns={columns}
            dataSource={data}
            pagination={{
              total: totalCount,
              defaultPageSize: pageSize,
              showSizeChanger: true,
              pageSizeOptions: ['20', '100', '200', '500'],
            }}
            onChange={onPaginationChange}
          />
        </div>
      ) : null}
    </>
  );
};

export default ClassTable;
